import type { PostingNode } from '@revelio/data-access';

import { findFilterById } from '../../../filters/engine/filterRegistry';
import {
  type Filter,
  FilterId,
  FilterType,
  isMultiFilter,
  type TreeFilter,
} from '../../../filters/types/filters';
import { makeRicsLeaf } from './company';
import { buildTreeFilterNodes, wrapExprNode } from './node-builders';

export const buildIndustryFilter = (filters: Filter[]): PostingNode | null => {
  const industryFilter = findFilterById(filters, FilterId.INDUSTRY);
  if (!industryFilter || industryFilter.type !== FilterType.TREE) {
    return null;
  }

  const exprNode = buildTreeFilterNodes(industryFilter, makeRicsLeaf);
  if (!exprNode) return null;

  return wrapExprNode(exprNode, industryFilter.isNot);
};

export const buildMultiIndustryFilter = (
  filters: Filter[]
): PostingNode | PostingNode[] | null => {
  const multiIndustry = findFilterById(filters, FilterId.MULTI_INDUSTRY);
  if (!multiIndustry || !isMultiFilter(multiIndustry)) {
    return null;
  }
  if (multiIndustry.instances.length === 0) {
    return null;
  }

  const instanceNodes = multiIndustry.instances
    .filter((inst): inst is TreeFilter => inst?.type === FilterType.TREE)
    .map((instance) => {
      const exprNode = buildTreeFilterNodes(instance, makeRicsLeaf);
      if (!exprNode) return null;
      return wrapExprNode(exprNode, instance.isNot);
    })
    .filter((node): node is PostingNode => node !== null);

  if (instanceNodes.length === 0) return null;
  if (instanceNodes.length === 1) {
    const [singleNode] = instanceNodes;
    return singleNode ?? null;
  }
  return instanceNodes;
};
